import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import LogInModal from 'flarum/forum/components/LogInModal';
import SiteSidebar from './SiteSidebar';
import { icon } from './ui';
const statusLabel = {
  draft: 'Szkic',
  submitted: 'Złożona',
  triage: 'Weryfikacja',
  open: 'W toku',
  hearing: 'Rozprawa',
  decision: 'Decyzja',
  appeal: 'Odwołanie',
  closed: 'Zamknięta',
  rejected: 'Odrzucona',
  withdrawn: 'Wycofana'
};
const categoryLabel = {
  appeal: 'Odwołanie od kary',
  player_report: 'Zgłoszenie gracza',
  transaction: 'Spór transakcyjny',
  administration: 'Skarga na administrację',
  other: 'Inna sprawa'
};
export default class CourtPage extends Page {
  data = null;
  loading = true;
  error = '';
  notice = '';
  selected = 0;
  mode = 'list';
  form = {
    category: 'appeal',
    title: '',
    respondent_username: '',
    summary: '',
    desired_resolution: '',
    penalty_id: ''
  };
  message = '';
  evidence = {
    title: '',
    url: '',
    description: ''
  };
  appeal = '';
  staffReason = 'Obsługa sprawy w Nova Court';
  decision = {
    verdict: 'accepted',
    reasoning: '',
    mta_action: 'none',
    account_id: '',
    amount_cents: '',
    duration_minutes: '',
    reason: '',
    simulate: false
  };
  oninit(v) {
    super.oninit(v);
    this.selected = Number(m.route.param('id') || 0);
    this.load();
  }
  oncreate() {
    window.scrollTo(0, 0);
    document.title = 'Sąd - NovaTruck & RP';
  }
  endpoint() {
    return `${String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '')}/nova/court`;
  }
  async load() {
    if (!app.session.user) {
      this.loading = false;
      return;
    }
    this.loading = true;
    this.error = '';
    try {
      this.data = await app.request({
        method: 'GET',
        url: `${this.endpoint()}${this.selected ? `?case_id=${this.selected}` : ''}`
      });
      this.mode = this.selected ? 'detail' : 'list';
    } catch (e) {
      this.error = e?.response?.errors?.[0]?.detail || 'Nie udało się pobrać spraw.';
    }
    this.loading = false;
    m.redraw();
  }
  async act(body) {
    this.error = '';
    this.notice = '';
    try {
      const r = await app.request({
        method: 'POST',
        url: `${this.endpoint()}/action`,
        body
      });
      this.notice = 'Operacja została zapisana w historii sprawy.';
      if (body.action === 'create') {
        this.selected = Number(r?.result?.case_id || 0);
        m.route.set(`/sad/${this.selected}`);
      } else await this.load();
    } catch (e) {
      this.error = e?.response?.errors?.[0]?.detail || 'Operacja nie powiodła się.';
      m.redraw();
    }
  }
  open(id) {
    this.selected = id;
    m.route.set(`/sad/${id}`);
    this.load();
  }
  input(label, key, o, type) {
    if (type === void 0) {
      type = 'text';
    }
    return m("label", null, m("span", null, label), m("input", {
      className: "FormControl",
      type: type,
      value: o[key] ?? '',
      oninput: e => o[key] = e.target.value
    }));
  }
  view() {
    return m("div", {
      className: "NtCourtPage"
    }, m("div", {
      className: "container NtSubpageLayout"
    }, m(SiteSidebar, null), m("main", null, m("header", {
      className: "NtPageHeading"
    }, m("small", null, "NOVA JUSTICE \u2022 FORUM + MTA"), m("h1", null, "Centrum spraw i odwo\u0142a\u0144"), m("p", null, "Prywatne post\u0119powania, dowody, decyzje i kontrolowana \u015Bcie\u017Cka odwo\u0142awcza.")), !app.session.user ? this.guest() : this.loading ? m(LoadingIndicator, null) : m('[', null, this.error ? m("div", {
      className: "Alert Alert--error"
    }, this.error) : null, this.notice ? m("div", {
      className: "Alert Alert--success"
    }, this.notice) : null, this.mode === 'create' ? this.createForm() : this.selected ? this.detail() : this.list()))));
  }
  guest() {
    return m("section", {
      className: "NtCourtEmpty"
    }, icon('fas fa-lock'), m("h2", null, "Wymagane logowanie"), m("p", null, "Sprawy s\u0105 prywatne i widoczne wy\u0142\u0105cznie dla stron oraz uprawnionej administracji."), m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(LogInModal)
    }, "Zaloguj si\u0119"));
  }
  list() {
    const cases = this.data?.cases || [],
      notifications = this.data?.notifications || [];
    return m('[', null, notifications.length ? m("section", {
      className: "NtCourtNotifications"
    }, m("h3", null, icon('fas fa-bell'), " Powiadomienia"), notifications.map(n => m("div", null, m("b", null, n.title), m("span", null, n.message), m("small", null, n.created_at)))) : null, m("div", {
      className: "NtCourtToolbar"
    }, m("div", null, m("b", null, "Twoje sprawy"), m("small", null, this.data?.staff ? 'Tryb obsługi administracyjnej' : 'Widoczne tylko dla uczestników')), m("button", {
      className: "Button Button--primary",
      onclick: () => {
        this.mode = 'create';
      }
    }, icon('fas fa-plus'), " Nowa sprawa")), m("div", {
      className: "NtCourtCases"
    }, cases.length ? cases.map(c => m("button", {
      onclick: () => this.open(c.id)
    }, m("span", {
      className: `NtCourtStatus is-${c.status}`
    }, statusLabel[c.status] || c.status), m("div", null, m("small", null, c.public_id, " \u2022 ", categoryLabel[c.category] || c.category), m("h2", null, c.title), m("p", null, c.claimant_username || '—', " kontra ", c.respondent_username || 'do ustalenia')), m("aside", null, m("small", null, "Aktualizacja"), m("b", null, c.updated_at), icon('fas fa-chevron-right')))) : m("section", {
      className: "NtCourtEmpty"
    }, m("h2", null, "Brak spraw"), m("p", null, "Mo\u017Cesz z\u0142o\u017Cy\u0107 odwo\u0142anie, zg\u0142oszenie gracza albo sp\xF3r transakcyjny."))));
  }
  createForm() {
    const f = this.form;
    return m("section", {
      className: "NtCourtForm"
    }, m("button", {
      className: "Button",
      onclick: () => {
        this.mode = 'list';
      }
    }, "\u2190 Wr\xF3\u0107"), m("h2", null, "Nowa sprawa"), m("p", null, "Opisz sytuacj\u0119 rzeczowo. Dowody dodasz po utworzeniu szkicu."), m("div", {
      className: "NtCourtFormGrid"
    }, m("label", null, m("span", null, "Rodzaj sprawy"), m("select", {
      className: "FormControl",
      value: f.category,
      onchange: e => f.category = e.target.value
    }, Object.entries(categoryLabel).map(_ref => {
      let [k, v] = _ref;
      return m("option", {
        value: k
      }, String(v));
    }))), this.input('Tytuł', 'title', f), this.input('Druga strona — nick forum', 'respondent_username', f), this.input('ID kary, jeśli dotyczy', 'penalty_id', f, 'number'), m("label", {
      className: "wide"
    }, m("span", null, "Opis zdarzenia"), m("textarea", {
      className: "FormControl",
      value: f.summary,
      oninput: e => f.summary = e.target.value
    })), m("label", {
      className: "wide"
    }, m("span", null, "Oczekiwane rozwi\u0105zanie"), m("textarea", {
      className: "FormControl",
      value: f.desired_resolution,
      oninput: e => f.desired_resolution = e.target.value
    }))), m("button", {
      className: "Button Button--primary",
      onclick: () => this.act({
        action: 'create',
        ...f,
        penalty_id: Number(f.penalty_id) || null
      })
    }, "Utw\xF3rz bezpieczny szkic"));
  }
  detail() {
    const c = this.data?.case;
    if (!c) return m("section", {
      className: "NtCourtEmpty"
    }, "Nie znaleziono sprawy.");
    return m('[', null, m("div", {
      className: "NtCourtCaseHead"
    }, m("button", {
      className: "Button",
      onclick: () => {
        this.selected = 0;
        m.route.set('/sad');
        this.load();
      }
    }, "\u2190 Lista"), m("div", null, m("small", null, c.public_id, " \u2022 ", categoryLabel[c.category] || c.category), m("h2", null, c.title), m("p", null, c.summary)), m("span", {
      className: `NtCourtStatus is-${c.status}`
    }, statusLabel[c.status] || c.status)), m("div", {
      className: "NtCourtMeta"
    }, m("span", null, m("small", null, "Wnioskodawca"), m("b", null, this.party('claimant'))), m("span", null, m("small", null, "Druga strona"), m("b", null, this.party('respondent'))), m("span", null, m("small", null, "Prowadz\u0105cy"), m("b", null, this.party('judge'))), m("span", null, m("small", null, "Priorytet"), m("b", null, c.priority))), this.data?.staff ? this.staff(c) : null, m("section", {
      className: "NtCourtSection"
    }, m("h2", null, icon('fas fa-comments'), " Pok\xF3j sprawy"), m("div", {
      className: "NtCourtMessages"
    }, (this.data.messages || []).map(x => m("article", {
      className: `is-${x.message_type}`
    }, m("header", null, m("b", null, x.username || 'System'), m("small", null, x.created_at), this.data.staff ? m("button", {
      onclick: () => this.act({
        action: 'moderate_message',
        case_id: c.id,
        message_id: x.id,
        reason: this.staffReason
      })
    }, icon('fas fa-trash')) : null), m("p", null, x.message)))), !['closed', 'rejected', 'withdrawn'].includes(c.status) ? m("form", {
      onsubmit: e => {
        e.preventDefault();
        this.message.trim() && this.act({
          action: 'message',
          case_id: c.id,
          message: this.message
        }).then(() => this.message = '');
      }
    }, m("textarea", {
      className: "FormControl",
      placeholder: "Napisz wypowied\u017A\u2026",
      value: this.message,
      oninput: e => this.message = e.target.value
    }), m("button", {
      className: "Button Button--primary"
    }, "Wy\u015Blij")) : null), m("section", {
      className: "NtCourtSection"
    }, m("h2", null, icon('fas fa-paperclip'), " Dowody"), m("div", {
      className: "NtEvidenceGrid"
    }, (this.data.evidence || []).map(x => m("article", null, m("span", {
      className: `is-${x.status}`
    }, x.status), m("h3", null, x.title), m("p", null, x.description || 'Bez opisu'), m("a", {
      href: x.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Otw\xF3rz dow\xF3d"), m("small", null, "Skr\xF3t: ", String(x.reference_hash).slice(0, 14), "\u2026"), this.data.staff ? m("div", null, m("button", {
      onclick: () => this.act({
        action: 'review_evidence',
        case_id: c.id,
        evidence_id: x.id,
        status: 'accepted',
        reason: this.staffReason
      })
    }, "Akceptuj"), m("button", {
      onclick: () => this.act({
        action: 'review_evidence',
        case_id: c.id,
        evidence_id: x.id,
        status: 'rejected',
        reason: this.staffReason
      })
    }, "Odrzu\u0107")) : null))), !['closed', 'rejected', 'withdrawn'].includes(c.status) ? m("div", {
      className: "NtCourtEvidenceForm"
    }, this.input('Nazwa dowodu', 'title', this.evidence), this.input('Adres HTTPS', 'url', this.evidence, 'url'), m("label", null, m("span", null, "Opis"), m("textarea", {
      className: "FormControl",
      value: this.evidence.description,
      oninput: e => this.evidence.description = e.target.value
    })), m("button", {
      className: "Button",
      onclick: () => this.act({
        action: 'evidence',
        case_id: c.id,
        ...this.evidence
      })
    }, "Dodaj dow\xF3d")) : null), (this.data.decisions || []).map(d => m("section", {
      className: "NtCourtDecision"
    }, m("small", null, "ORZECZENIE \u2022 ", d.created_at), m("h2", null, d.verdict), m("p", null, d.reasoning), m("b", null, "Prowadz\u0105cy: ", d.username), m("small", null, "Odwo\u0142anie do: ", d.appeal_deadline || '—'), d.mta_action && d.mta_action !== 'none' ? m("div", {
      className: `NtCourtMtaStatus is-${d.mta_status || 'pending'}`
    }, m("strong", null, d.mta_simulated ? 'SYMULACJA MTA' : 'MTA', ": ", d.mta_action), m("span", null, d.mta_status || 'pending', " \u2014 ", d.mta_result || 'oczekuje na odpowiedź bridge')) : null)), c.status === 'draft' ? m("div", {
      className: "NtCourtActions"
    }, m("button", {
      className: "Button Button--primary",
      onclick: () => this.act({
        action: 'submit',
        case_id: c.id
      })
    }, "Przeka\u017C administracji"), m("button", {
      className: "Button",
      onclick: () => this.act({
        action: 'withdraw',
        case_id: c.id
      })
    }, "Wycofaj")) : null, ['decision', 'closed'].includes(c.status) ? m("section", {
      className: "NtCourtForm"
    }, m("h2", null, "Z\u0142\xF3\u017C odwo\u0142anie"), m("textarea", {
      className: "FormControl",
      value: this.appeal,
      oninput: e => this.appeal = e.target.value
    }), m("button", {
      className: "Button",
      onclick: () => this.act({
        action: 'appeal',
        case_id: c.id,
        reason: this.appeal
      })
    }, "Z\u0142\xF3\u017C odwo\u0142anie")) : null);
  }
  party(role) {
    return this.data?.parties?.find(x => x.party_role === role)?.username || 'Nie przypisano';
  }
  staff(c) {
    return m("section", {
      className: "NtCourtStaff"
    }, m("h2", null, icon('fas fa-user-shield'), " Obs\u0142uga sprawy"), m("label", null, m("span", null, "Pow\xF3d operacji"), m("input", {
      className: "FormControl",
      value: this.staffReason,
      oninput: e => this.staffReason = e.target.value
    })), m("div", null, m("select", {
      className: "FormControl",
      value: c.status,
      onchange: e => this.act({
        action: 'set_status',
        case_id: c.id,
        status: e.target.value,
        reason: this.staffReason
      })
    }, ['submitted', 'triage', 'open', 'hearing', 'decision', 'appeal', 'closed', 'rejected'].map(x => m("option", {
      value: x
    }, statusLabel[x])))), m("h3", null, "Wydaj decyzj\u0119"), m("div", {
      className: "NtCourtFormGrid"
    }, m("label", null, m("span", null, "Werdykt"), m("select", {
      className: "FormControl",
      value: this.decision.verdict,
      onchange: e => this.decision.verdict = e.target.value
    }, m("option", {
      value: "accepted"
    }, "Uwzgl\u0119dniona"), m("option", {
      value: "partially_accepted"
    }, "Cz\u0119\u015Bciowo uwzgl\u0119dniona"), m("option", {
      value: "rejected"
    }, "Oddalona"), m("option", {
      value: "dismissed"
    }, "Umorzona"))), m("label", null, m("span", null, "Dzia\u0142anie MTA"), m("select", {
      className: "FormControl",
      value: this.decision.mta_action,
      onchange: e => this.decision.mta_action = e.target.value
    }, ['none', 'warning', 'fine', 'ban', 'license_suspension', 'revoke_penalty'].map(x => m("option", {
      value: x
    }, x)))), this.input('ID konta MTA', 'account_id', this.decision, 'number'), this.input('Kwota w groszach', 'amount_cents', this.decision, 'number'), this.input('Czas w minutach', 'duration_minutes', this.decision, 'number'), m("label", {
      className: "wide"
    }, m("span", null, "Uzasadnienie"), m("textarea", {
      className: "FormControl",
      value: this.decision.reasoning,
      oninput: e => this.decision.reasoning = e.target.value
    })), this.input('Powód dla serwera MTA', 'reason', this.decision), m("label", {
      className: "check wide"
    }, m("input", {
      type: "checkbox",
      checked: !!this.decision.simulate,
      onchange: e => this.decision.simulate = e.target.checked
    }), m("span", null, "Tryb symulacji \u2014 waliduj komend\u0119 w bridge MTA bez wykonania kary"))), m("button", {
      className: "Button Button--primary",
      onclick: () => this.act({
        action: 'decision',
        case_id: c.id,
        verdict: this.decision.verdict,
        reasoning: this.decision.reasoning,
        mta_action: this.decision.mta_action,
        action_payload: {
          account_id: Number(this.decision.account_id) || 0,
          amount_cents: Number(this.decision.amount_cents) || 0,
          duration_minutes: Number(this.decision.duration_minutes) || 0,
          reason: this.decision.reason
        },
        simulate: !!this.decision.simulate,
        reason: this.staffReason
      })
    }, "Zapisz orzeczenie"));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/CourtPage', CourtPage);